// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../contants/global.const';
import { SEND_SERVICE } from '../../../services/send.service';

@Injectable()
export class DepositsService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getByProcessId<T>(params): Observable<T> {
    // const url = this.Global.services.deposits.getByProcessId();
    const url = this.Global.services.process.list();
    return this.sendService.get(url);
    // return this.sendService.get(url, { params });
  }

  public deposits<T>(body, params): Observable<T> {
    const url = this.Global.services.deposits.deposits();
    return this.sendService.post(url, body, { params });
  }
}
